// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__gnnjq","noInteraction":"EventWrapper_noInteraction__T0rCn","pointerPassthrough":"EventWrapper_pointerPassthrough__3hdZc"};